import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpErrorResponse
} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';
import { TokenService } from '../services/token.service';
import { NotificationService } from '@app/modules/lps-member-login/components/shared/services/notifications.service';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {

  constructor(private tokenService: TokenService,private notificationService : NotificationService) {}

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    // Check if token is expired before making the request
    if (this.tokenService.isTokenExpired()) {
      console.warn('Token expired before request. Performing automatic logout.');
      this.tokenService.autoLogout();
      return throwError(() => new Error('Token expired'));
    }

    // Get the token from the token service
    const token = this.tokenService.getToken();

    // If token exists and is valid, add it to the request headers
    if (token && this.tokenService.hasValidToken()) {
      request = request.clone({
        setHeaders: {
          Authorization: `Bearer ${token}`
        }
      });
    }

    // Handle the request and catch any errors
    return next.handle(request).pipe(
      tap(() => {
        // Check token expiration after successful request
        if (this.tokenService.isTokenExpired()) {
          this.notificationService.showNotification('Token expired', 'Please log in again.');
          console.warn('Token expired after request. Performing automatic logout.');
          this.tokenService.autoLogout();
        }
      }),
      catchError((error: HttpErrorResponse) => {
        // If we get a 401 Unauthorized error, the token might be expired
        if (error.status === 401) {
          this.notificationService.showNotification('Unauthorized access.', 'Please log in again.');
          console.warn('401 Unauthorized. Token expired or invalid. Performing automatic logout.');
           this.tokenService.autoLogout();
          
        }
        
        // If we get a 403 Forbidden error, the token might be invalid
        if (error.status === 403) {
          console.warn('403 Forbidden. Access denied. Performing automatic logout.');
          this.notificationService.showNotification("403 Forbidden. Access denied. Performing automatic logout.",'error');
          this.tokenService.autoLogout();
        }

        // Return the error to be handled by the calling component
        return throwError(() => error);
      })
    );
  }
}
